// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import cn from 'classnames';
import date from '/util/date.js';
import {Button} from '../../../hola/pub/lib/button';
import {Checkbox} from '../../../hola/pub/lib/checkbox';
import Icon_cookie from '../../img/icons/32/cookie_fill.svg';
// @ts-ignore
import cookie from 'cookie';
import {after_apply_cookie, perr} from 'hola_pub_util';
import etask from 'zetask';
import hola_opt from 'hola_opt';
import experiment_init from '../../../hola/pub/experiment_init';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_screen} from '../../../hola/pub/lib/screen_util';

import styles from './cookie_consent.module.less';

interface i_consent_props {
    on_apply: ()=>void;
    cookie_name?: string;
    is_toolip?: boolean;
    is_oculus?: boolean;
    is_browserai?: boolean;
}

interface i_clarity_consent {
   ad_storage: 'granted' | 'denied',
   analytics_storage: 'granted' | 'denied';
}

export const Cookie_consent = (props: i_consent_props)=>{
    const {theme, theme_name} = useContext(Settings_context);
    const [is_full, set_is_full] = useState(false);
    const [is_pers, set_is_pers] = useState(true);
    const [is_perf, set_is_perf] = useState(true);
    const [is_mark, set_is_mark] = useState(true);
    const [is_client, set_is_client] = useState(false);
    const site = props.is_oculus ? 'Oculus' :
        props.is_toolip ? 'Toolip' :
        props.is_browserai ? 'BrowserAI' :
        'Hola';
    useEffect(()=>{
        set_is_client(true);
        perr({id: 'www_cookie_consent_show'});
    }, []);
    const set_cookie = ({pers, perf, mark}, id)=>etask(function*(){
        const obj = {
            n: true,
            pers, perf, mark,
        };
        cookie.set(props.cookie_name || 'allow_hola_cookie',
          JSON.stringify(obj),
          {domain: `.${window.location.host}`,
            path: '/', expires: date.add(date(), {year: 10})});
        yield perr({id});
        Object.assign(hola_opt.cookie_value_parsed, obj);
        if (hola_opt.temp_cookie)
        {
            hola_opt.temp_cookie.forEach(cookie_line=>{
                if (obj[cookie_line[3]])
                    cookie.set(cookie_line[0], cookie_line[1], cookie_line[2]);
            });
        }
        if (pers || perf || mark)
            experiment_init.move_it_to_cookie({host: window.location.host});
        // for setting xsrf token
        yield fetch('/ping');
        // @ts-ignore
        if (window.for_eval_when_cookie_ready && mark)
        {
            // @ts-ignore
            window.for_eval_when_cookie_ready.forEach(code=>{
                eval(code);
            });
        }
        after_apply_cookie();
        // @ts-ignore
        if (window.global_etask_for_wait_cookie)
        {
            // @ts-ignore
            window.global_etask_for_wait_cookie.forEach(resolve=>{
                resolve();
            });
        }
        window.dispatchEvent(new CustomEvent('session_changed'));
        props.on_apply();
    });
    const {width, height} = use_screen();
    const [fc_h, set_fc_h] = useState(205);
    useEffect(()=>{
        const fc_el = document.getElementById('content_of_consent');
        if (fc_el)
        {
            setTimeout(()=>{
                set_fc_h(fc_el.offsetHeight);
            }, 0);
            set_fc_h(fc_el.offsetHeight);
        }
    }, [width, is_full, fc_h, height, is_client]);
    if (!is_client)
        return <Fragment></Fragment>;
    const gtag = (params: object)=>
        (window as any)?.gtag?.('consent', 'default', params);
    const clarity_consent = (data: i_clarity_consent)=>{
        if (typeof window !== 'undefined' && window.clarity)
        {
            window.clarity('consentv2', {
                ad_Storage: data.ad_storage,
                analytics_Storage: data.analytics_storage,
            });
        }
    };
    return <div className={cn(styles.overlay, styles.with_blur)}>
      <div id={'fixed_container'}
        style={{
          '--fc_h': `${fc_h}px`,
          '--fc_h2': `${Math.round(fc_h/2)}px`,
        } as any}
        className={cn(styles.fixed_container, is_full && styles.center)}>
        <div id={'content_of_consent'}
          className={cn(styles.content_of_consent, is_full ?
          styles.full : styles.small)}>
          <div className={cn(styles.short, is_full && styles.hidden)}>
            <div className={styles.cookie_icon_wrapper}>
              <Icon_cookie className={styles.cookie_icon}/>
            </div>
            <p className={cn(
              theme_name=='toolip' || theme_name=='oculus' ? theme.p20 :
              theme.p4,
              theme.med,
              styles.short_title
            )}>
              We value your privacy
            </p>
            <p
              className={cn(
                theme_name=='toolip' || theme_name=='oculus'
                  ? theme.p16
                  : theme.p4,
                theme.reg,
                styles.short_text
              )}
            >
              We recommend you accept all cookies for the optimal experience
              when using our website.
            </p>
          </div>
          <div className={cn(styles.full_data, !is_full && styles.hidden)}>
            <p className={cn(theme.p3, theme.med, styles.title,
              styles.accent)}>
                {site} uses cookies to optimize your experience</p>
            <p className={cn(theme.p4, theme.reg, styles.m24)}>We use cookies
              because they
              are necessary for our website to function. We use other cookies
              to enhance your experience by providing insights on how you use
              our website. We recommend accepting all cookies to get the most
              value when using our website. You can learn more about each
              category of cookies by reading our Privacy Policy</p>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Necessary cookies</p>
                <p className={cn(theme.p4, theme.reg)}>Necessary cookies
                  provide core functionality and are essential for the
                  website to perform properly. They are enabled by default
                  and cannot be disabled.</p>
              </div>
              <Checkbox checked={true} on_change={()=>{
                perr({id: 'www_cookie_consent_try_turnoff_n'});
              }} mode={'toggle'} disabled/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Personalization cookies</p>
                <p className={cn(theme.p4, theme.reg)}>Personalization cookies
                  help us customize the content you see on this website based
                  on your usage.</p>
              </div>
              <Checkbox checked={is_pers} on_change={set_is_pers}
                mode={'toggle'}/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Performance cookies</p>
                <p className={cn(theme.p4, theme.reg)}>These cookies allow us
                  to monitor and improve website performance.</p>
              </div>
              <Checkbox checked={is_perf} on_change={set_is_perf}
                mode={'toggle'}/>
            </div>
            <div className={styles.cookie_line}>
              <div className={styles.text}>
                <p className={cn(theme.p4, theme.bold, styles.line_title)}>
                  Marketing cookies</p>
                <p className={cn(theme.p4, theme.reg)}>These cookies increase
                the value of the campaigns and offers you receive by
                tailoring them to your specific needs.</p>
              </div>
              <Checkbox checked={is_mark} on_change={set_is_mark}
                mode={'toggle'}/>
            </div>
          </div>
          <div className={styles.buttons}>
            <Button caption={is_full ? 'Save settings' : 'Cookies settings'}
              color={'white'}
              size='xs'
              on_click={()=>{
                if (is_full)
                {
                  set_cookie({perf: is_perf, pers: is_pers,
                    mark: is_mark}, 'www_cookie_consent_click_save');
                  const consent_params = {};
                  if (is_pers)
                    consent_params['ad_personalization'] = 'granted';
                  if (is_mark)
                  {
                    consent_params['ad_storage'] = 'granted';
                    consent_params['ad_user_data'] = 'granted';
                    consent_params['analytics_storage'] = 'granted';
                  }
                  if (Object.keys(consent_params).length)
                    gtag(consent_params);
                  const ad = is_mark ? 'granted' : 'denied';
                  const analytics =
                    is_perf || is_pers || is_mark ? 'granted' : 'denied';
                  clarity_consent({
                    ad_storage: ad,
                    analytics_storage: analytics
                  });
                }
                else
                {
                  perr({id: 'www_cookie_consent_open_full'});
                  set_is_full(true);
                }
              }} no_jump/>
            <Button caption={'Analytics only'} color={'white'}
              size='xs' on_click={()=>{
                set_cookie({perf: false, pers: false, mark: true},
                  'www_cookie_consent_click_analytics');
                gtag({analytics_storage: 'granted'});
                clarity_consent({
                  ad_storage: 'denied',
                  analytics_storage: 'granted'
                });
              }} no_jump/>
            <Button caption={'Accept all'}
              color={theme_name=='hola2023' ? 'black2023' : 'black'}
              size='xs'
              on_click={()=>{
                set_cookie({perf: true, pers: true, mark: true},
                  'www_cookie_consent_click_all');
                gtag({
                  ad_storage: 'granted',
                  ad_user_data: 'granted',
                  ad_personalization: 'granted',
                  analytics_storage: 'granted',
                });
                clarity_consent({
                  ad_storage: 'granted',
                  analytics_storage: 'granted'
                });
              }} no_jump/>
          </div>
        </div>
      </div>
    </div>;
};
